import { FiLock, FiShield } from 'react-icons/fi';
import { FcGoogle } from 'react-icons/fc';

const AuthGuard = ({ user, children, onSignIn }) => {
  if (!user) {
    return (
      <div className="min-h-[400px] flex items-center justify-center">
        <div className="text-center max-w-md mx-auto">
          <div className="p-4 bg-blue-50 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
            <FiLock className="h-10 w-10 text-blue-600" />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Sign In Required
          </h2>
          
          <p className="text-gray-600 mb-8">
            You need to sign in with your Google account to create and manage short URLs.
          </p>
          
          <button
            onClick={onSignIn}
            className="inline-flex items-center gap-3 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            <FcGoogle className="h-6 w-6" />
            Sign in with Google
          </button>
          
          <div className="mt-8 flex items-center gap-2 text-sm text-gray-500">
            <FiShield className="h-4 w-4" />
            <span>Your data is secure and private</span>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthGuard; 